import React from "react";
import { BoxProps } from "../Box";
import { CircleLoader } from "../Loader";
import { Skeleton } from "../Skeleton";
import { Text } from "../Text";
import { StateFrame } from "./styles";

export interface LoadingStateProps extends BoxProps {
  /** Short label, e.g. "Loading farms". Defaults to no text (spinner only). */
  label?: string;
  /** Render N skeleton rows instead of a spinner (table/list placeholders). */
  rows?: number;
  rowHeight?: string;
  /** Spinner size in px. */
  size?: number;
}

/**
 * Loading: no numbers shown, ever — a skeleton or a spinner. Never a zero.
 */
export const LoadingState: React.FC<React.PropsWithChildren<LoadingStateProps>> = ({
  label,
  rows,
  rowHeight = "48px",
  size = 24,
  ...props
}) => {
  if (rows && rows > 0) {
    return (
      <StateFrame aria-busy="true" aria-live="polite" style={{ alignItems: "stretch" }} {...props}>
        {label && (
          <Text fontSize="14px" color="textSubtle" mb="12px" textAlign="center">
            {label}
          </Text>
        )}
        {Array.from({ length: rows }).map((_, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Skeleton key={i} height={rowHeight} width="100%" mb={i === rows - 1 ? "0" : "8px"} variant="round" />
        ))}
      </StateFrame>
    );
  }
  return (
    <StateFrame aria-busy="true" aria-live="polite" {...props}>
      <CircleLoader size={`${size}px`} />
      {label && (
        <Text fontSize="14px" color="textSubtle" mt="12px">
          {label}
        </Text>
      )}
    </StateFrame>
  );
};

export default LoadingState;
